import React, { useCallback } from 'react';
import classNames from 'classnames';

import { Tappable } from '@common/ui/general';
import { requestCallback } from '../../utils/RequestCallback';
import { useChatbotContext } from '~chatbot/context/ChatbotContext';
import { handleTracking } from '~chatbot/utils/analytics';

import styles from './RequestCallback.module.scss';

function RequestCallback({ className }) {
  const { setisOpenWidget } = useChatbotContext();

  const handleRequestCallback = useCallback(() => {
    handleTracking({
      click_type: 'bot_request_callback_cta_block',
      click_text: '',
      element: 'bot rcb cta',
    });
    setisOpenWidget(false);
    requestCallback();
  }, [setisOpenWidget]);

  return (
    <Tappable
      onClick={handleRequestCallback}
      className={classNames(styles.rcbCta, className)}
    >
      Request a callback
    </Tappable>
  );
}

export default RequestCallback;
